const vImgError = { // 名字爱取啥取啥
    async bind(el,value){
        let imgURL = el.src;//获取图片地址
        if (imgURL) {
            let exist = await imageIsExist(imgURL);

            if (!exist) {
                el.setAttribute('src',value.value);
            }
        }
    }
    
}
let imageIsExist = function(url) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
            if (this.complete == true){
                resolve(true);
                img = null;
            }
        }
        img.onerror = function () {
            resolve(false);
            img = null;
        }
        img.src = url;
    })
}
 
export default vImgError;


// WEBPACK FOOTER //
// ./src/util/toolClass/imgCheck.js